import React from "react";
import Typography from "../Typography/Typography";
import { PackageNames } from "../../store/interface";

interface PickPlanItemProps {
  planID: PackageNames;
  monlthlyPrice: string;
  discount?: string;
  selectedPlan: PackageNames;
  setSelectedPlan: (planID: PackageNames) => void;
}

const renderTitle = (planID: PackageNames) => {
  switch (planID) {
    case PackageNames["Quarterly Subscription"]:
      return "Premium 3 Months";
    case PackageNames["Yearly Subscription"]:
      return "Premium 12 Months";
    case PackageNames["Biennial Subscription"]:
      return "Premium 24 Months";
    default:
      return "";
  }
};

const PickPlanItem = ({
  planID,
  monlthlyPrice,
  discount,
  selectedPlan,
  setSelectedPlan,
}: PickPlanItemProps) => {
  return (
    <div
      className={`rounded-20   ${
        selectedPlan === planID
          ? "bg-border-gradient p-4"
          : "bg-light-grey-10 p-[2px]"
      }`}
    >
      <div
        onClick={() => {
          setSelectedPlan(planID);
        }}
        className={`bg-white cursor-pointer p-16 lg:p-24 pr-12 lg:pr-16 hover:bg-[#F5F5FC] ${
          selectedPlan === planID ? "rounded-2xl" : "rounded-[18px]"
        } flex justify-between relative`}
      >
        {discount && discount !== "0%" && (
          <div className="absolute right-24 lg:right-24 -top-[12.5px] h-[25px] px-8 bg-[#EA2D71] text-white text-xs rounded-20 !font-semibold flex items-center">
            SAVE {discount}*
          </div>
        )}

        <Typography type="Body2">{renderTitle(planID)}</Typography>

        <div className="text-end">
          <Typography type="Body2" className="!font-bold">
            ${(+monlthlyPrice).toFixed(3).slice(0, -1)}
          </Typography>
          <Typography type="Body3" className="text-dark-grey-5 font-bold">
            month / license{" "}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default PickPlanItem;
